const { prop } = require('ramda');

module.exports = (value) => {
  const name = prop('name')(value);

  if (!name) {
    return '';
  } else {
    return name;
  }
};
